import React from 'react';
import { Briefcase, Calendar, CheckCircle, AlertCircle } from 'lucide-react';

const EmployeeTaskList = ({ tasks = [] }) => {
    // Sort latest created/updated first so newly assigned/completed tasks appear on top.
    const sortedTasks = [...tasks].sort((a, b) => {
        const aTs = new Date(a.CreatedAt || a.UpdatedAt || 0).getTime() || 0;
        const bTs = new Date(b.CreatedAt || b.UpdatedAt || 0).getTime() || 0;
        return bTs - aTs;
    });

    return (
        <div style={{ background: 'white', borderRadius: '8px', border: '1px solid #ddd', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '1rem', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#f8f9fa', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                <Briefcase size={20} color="#007bff" />
                <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2c3e50' }}>My Assigned Tasks</h3>
                <span style={{ marginLeft: 'auto', background: '#e9ecef', padding: '0.2rem 0.6rem', borderRadius: '12px', fontSize: '0.8rem', fontWeight: 'bold', color: '#495057' }}>
                    {tasks.length}
                </span>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
                {tasks.length === 0 && (
                    <div style={{ textAlign: 'center', color: '#999', marginTop: '2rem' }}>
                        <CheckCircle size={48} color="#e9ecef" style={{ marginBottom: '1rem' }} />
                        <p>No tasks assigned to you yet.</p>
                    </div>
                )}

                {sortedTasks.map(task => (
                    <div key={task.TaskID} style={{
                        padding: '1rem', marginBottom: '0.75rem', borderRadius: '6px',
                        border: '1px solid #eee', background: task.Status === 'Completed' ? '#f8f9fa' : 'white',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)', transition: 'transform 0.1s',
                        opacity: task.Status === 'Completed' ? 0.7 : 1
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                            <h4 style={{ margin: 0, fontSize: '1rem', color: '#333' }}>{task.Title}</h4>
                            <span style={{
                                fontSize: '0.75rem', padding: '0.2rem 0.6rem', borderRadius: '10px',
                                background: task.Status === 'Pending' ? '#fff3cd' : task.Status === 'In Progress' ? '#cce5ff' : '#d4edda',
                                color: task.Status === 'Pending' ? '#856404' : task.Status === 'In Progress' ? '#004085' : '#155724'
                            }}>
                                {task.Status}
                            </span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', fontSize: '0.85rem', color: '#666' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                <AlertCircle size={14} />
                                {task.TaskType}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                <Calendar size={14} />
                                Due: {task.EndDate ? new Date(task.EndDate).toLocaleDateString() : 'No Deadline'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EmployeeTaskList;
